import React from 'react'
import { useMutation } from '@tanstack/react-query'
import { useAdminSociety } from '../../useAdminSociety'
import {
  Button,
  ButtonVariant,
} from '../../../../../../components/common/Button'
import { useToastNotifications } from '../../../../../../hooks/useToastNotification'
import { ToastType } from '../../../../../../components/common/Toast/toast-type'
import { useAppTranslation } from '../../../../../../hooks/useAppTranslation'
import { upgradeSociety } from '../../../../../../api/admin'

interface SetPremiumModalContentProps {
  close: () => void
  societyId: string | undefined
}

export const SetPremiumModalContent = ({
  close,
  societyId,
}: SetPremiumModalContentProps): React.ReactNode => {
  const { adminSociety } = useAdminSociety(societyId)
  const { setToastNotification } = useToastNotifications()
  const { translate } = useAppTranslation()

  const { mutate: mutateUpgradeSociety, isPending: isUpgradingSociety } =
    useMutation({
      mutationFn: upgradeSociety,
      onSuccess: () => {
        setToastNotification(ToastType.SUCCESS, 'Förening uppgraderad')
        close()
      },
      onError: () => {
        setToastNotification(
          ToastType.DANGER,
          translate('flashMessage.somethingWentWrongError')
        )
      },
    })

  const onUpgradeSociety = async (): Promise<void> => {
    societyId && mutateUpgradeSociety({ societyId })
  }

  if (!adminSociety) {
    return <p>Föreningen kunde inte hittas</p>
  }

  const alreadyPremium = adminSociety.accountType === 'premium'
  const loading = isUpgradingSociety

  return (
    <>
      <div className="flex h-full w-full flex-col gap-6">
        {alreadyPremium ? (
          <p>Föreningen är redan premium.</p>
        ) : (
          <>
            <p>
              {adminSociety.name} kommer att uppgraderas till <b>premium</b>.
            </p>
            <p>Föreningen kommer även att att låsas upp om den är låst.</p>
          </>
        )}
        <div className="flex flex-wrap justify-end gap-4">
          <Button label="Avbryt" onClick={close} />
          <Button
            variant={ButtonVariant.PRIMARY}
            label="Uppgradera"
            onClick={onUpgradeSociety}
            loading={loading}
            disabled={loading || alreadyPremium}
          />
        </div>
      </div>
    </>
  )
}
